import React, { useMemo, useState } from "react";

import {
    HeartOutlined,
    MedicineBoxOutlined,
    AppleOutlined,
    CalculatorOutlined,
    SearchOutlined,
    UserOutlined,
    ReadOutlined,
    RightOutlined,
    DashboardOutlined,
    ExperimentOutlined,
    FieldTimeOutlined,
    LineChartOutlined,
    CalendarOutlined,
    CheckSquareOutlined,
    RiseOutlined,
    SafetyCertificateOutlined
} from "@ant-design/icons";


export default function TienIch() {

    const [search, setSearch] = useState("");


    /*
     * NHÓM TIỆN ÍCH
     */
    const categories = [

        {
            name: "Theo dõi sức khỏe",
            description:
                "Ghi lại các chỉ số sức khỏe, lịch thuốc và lịch tái khám.",
            icon: <HeartOutlined />,
            color:
                "bg-red-50 text-red-500",
            link:
                "/tienich/suc-khoe",
            status:
                "ready",
            count:
                "6 tiện ích"
        },

        {
            name: "Phục hồi chức năng",
            description:
                "Theo dõi đau, ROM và lưu kết quả các đánh giá chức năng.",
            icon: <MedicineBoxOutlined />,
            color:
                "bg-blue-50 text-blue-600",
            link:
                "/tienich/phuc-hoi-chuc-nang",
            status:
                "ready",
            count:
                "6 tiện ích"
        },

        {
            name: "Dinh dưỡng",
            description:
                "Các công cụ hỗ trợ theo dõi dinh dưỡng và thói quen ăn uống.",
            icon: <AppleOutlined />,
            color:
                "bg-green-50 text-green-600",
            link:
                "/tienich/dinh-duong",
            status:
                "ready",
            count:
                "14 công cụ"
        },

        {
            name: "Công cụ Y khoa",
            description:
                "Các công cụ tính toán và hỗ trợ thực hành y khoa.",
            icon: <CalculatorOutlined />,
            color:
                "bg-purple-50 text-purple-600",
            link:
                "/tienich/cong-cu-y-khoa",
            status:
                "ready",
            count:
                "30 công cụ"
        }
    ];


    /*
     * TẤT CẢ CÔNG CỤ ĐANG HOẠT ĐỘNG
     */
    const tools = [

        {
            name: "Theo dõi huyết áp",
            description:
                "Ghi lại huyết áp và theo dõi sự thay đổi theo thời gian",
            group:
                "Theo dõi sức khỏe",
            icon:
                <HeartOutlined />,
            color:
                "bg-red-50 text-red-500",
            link:
                "/tienich/suc-khoe/huyet-ap"
        },

        {
            name: "Theo dõi đường huyết",
            description:
                "Ghi lại chỉ số đường huyết theo từng thời điểm",
            group:
                "Theo dõi sức khỏe",
            icon:
                <ExperimentOutlined />,
            color:
                "bg-rose-50 text-rose-500",
            link:
                "/tienich/suc-khoe/duong-huyet"
        },

        {
            name: "Theo dõi SpO₂",
            description:
                "Theo dõi độ bão hòa oxy trong máu",
            group:
                "Theo dõi sức khỏe",
            icon:
                <DashboardOutlined />,
            color:
                "bg-blue-50 text-blue-600",
            link:
                "/tienich/suc-khoe/spo2"
        },

        {
            name: "Theo dõi nhịp tim",
            description:
                "Ghi lại và theo dõi nhịp tim hằng ngày",
            group:
                "Theo dõi sức khỏe",
            icon:
                <LineChartOutlined />,
            color:
                "bg-pink-50 text-pink-500",
            link:
                "/tienich/suc-khoe/nhip-tim"
        },

        {
            name: "Lịch uống thuốc",
            description:
                "Quản lý lịch sử dụng thuốc hằng ngày",
            group:
                "Theo dõi sức khỏe",
            icon:
                <MedicineBoxOutlined />,
            color:
                "bg-green-50 text-green-600",
            link:
                "/tienich/suc-khoe/lich-thuoc"
        },

        {
            name: "Lịch tái khám",
            description:
                "Theo dõi lịch khám và các cuộc hẹn sức khỏe",
            group:
                "Theo dõi sức khỏe",
            icon:
                <CalendarOutlined />,
            color:
                "bg-purple-50 text-purple-600",
            link:
                "/tienich/suc-khoe/lich-tai-kham"
        },

        {
            name: "Nhật ký đau",
            description:
                "Theo dõi mức đau và các đặc điểm liên quan theo thời gian",
            group:
                "Phục hồi chức năng",
            icon:
                <HeartOutlined />,
            color:
                "bg-red-50 text-red-500",
            link:
                "/tienich/phuc-hoi-chuc-nang/nhat-ky-dau"
        },

        {
            name: "Theo dõi ROM",
            description:
                "Theo dõi tầm vận động chủ động và thụ động của khớp",
            group:
                "Phục hồi chức năng",
            icon:
                <RiseOutlined />,
            color:
                "bg-blue-50 text-blue-600",
            link:
                "/tienich/phuc-hoi-chuc-nang/rom"
        },

        {
            name: "Barthel Index",
            description:
                "Ghi nhận mức độ độc lập trong hoạt động hằng ngày",
            group:
                "Phục hồi chức năng",
            icon:
                <CheckSquareOutlined />,
            color:
                "bg-green-50 text-green-600",
            link:
                "/tienich/phuc-hoi-chuc-nang/barthel"
        },

        {
            name: "Berg Balance Scale",
            description:
                "Ghi nhận kết quả đánh giá thăng bằng chức năng",
            group:
                "Phục hồi chức năng",
            icon:
                <DashboardOutlined />,
            color:
                "bg-purple-50 text-purple-600",
            link:
                "/tienich/phuc-hoi-chuc-nang/berg"
        },

        {
            name: "Timed Up and Go",
            description:
                "Ghi lại kết quả đánh giá vận động TUG",
            group:
                "Phục hồi chức năng",
            icon:
                <FieldTimeOutlined />,
            color:
                "bg-orange-50 text-orange-500",
            link:
                "/tienich/phuc-hoi-chuc-nang/tug"
        },

        {
            name: "Đánh giá cơ lực MRC",
            description:
                "Ghi lại mức cơ lực theo thang điểm MRC",
            group:
                "Phục hồi chức năng",
            icon:
                <LineChartOutlined />,
            color:
                "bg-pink-50 text-pink-500",
            link:
                "/tienich/phuc-hoi-chuc-nang/mrc"
        }
    ];


    /*
     * TÌM KIẾM
     */
    const filteredTools = useMemo(() => {

        const keyword =
            search
                .trim()
                .toLocaleLowerCase("vi");


        if (!keyword) {

            return tools;
        }


        return tools.filter(
            (tool) => {

                const text =
                    `${tool.name} ${tool.description} ${tool.group}`
                        .toLocaleLowerCase("vi");


                return text.includes(keyword);
            }
        );

    }, [search]);


    return (

        <div className="max-w-screen-2xl mx-auto px-3 md:px-5 pb-10">


            {/* =========================
                HERO
            ========================== */}

            <div className="relative overflow-hidden bg-gradient-to-r from-blue-700 via-blue-600 to-cyan-500 rounded-2xl px-5 py-6 md:p-10 text-white">

                <div className="relative z-10 max-w-3xl">

                    <div className="flex items-center">

                        <div className="w-11 h-11 md:w-14 md:h-14 rounded-2xl bg-white bg-opacity-20 flex items-center justify-center text-xl md:text-3xl">

                            <MedicineBoxOutlined />

                        </div>


                        <div className="ml-3 md:ml-4">

                            <p className="text-[11px] md:text-sm font-semibold opacity-90">

                                CỬA HÀNG Y KHOA

                            </p>


                            <h1 className="text-[27px] md:text-4xl leading-tight font-bold">

                                Tiện ích Y khoa

                            </h1>

                        </div>

                    </div>


                    <p className="mt-4 text-[14px] md:text-lg leading-6 md:leading-7 opacity-90 max-w-2xl">

                        Ghi lại chỉ số sức khỏe, quản lý lịch chăm sóc
                        và theo dõi quá trình phục hồi trong cùng một nơi.

                    </p>


                    {/* SEARCH */}

                    <div className="mt-5 md:mt-7 bg-white rounded-2xl flex items-center px-4 h-12 md:h-14 shadow-sm">

                        <SearchOutlined className="text-gray-400 text-base md:text-lg" />


                        <input
                            type="text"
                            value={search}
                            onChange={(e) =>
                                setSearch(
                                    e.target.value
                                )
                            }
                            placeholder="Tìm huyết áp, ROM, nhật ký đau..."
                            className="w-full h-full ml-3 outline-none text-[14px] md:text-base text-gray-700 bg-transparent"
                        />


                        {search && (

                            <button
                                type="button"
                                onClick={() =>
                                    setSearch("")
                                }
                                className="text-xs font-semibold text-blue-600 ml-2 whitespace-nowrap"
                            >

                                Xóa

                            </button>

                        )}

                    </div>

                </div>


                <div className="hidden lg:block absolute -right-20 -bottom-28 w-96 h-96 rounded-full bg-white opacity-10" />

                <div className="hidden lg:block absolute right-44 -top-24 w-64 h-64 rounded-full bg-white opacity-5" />

            </div>


            {/* =========================
                NHÓM TIỆN ÍCH
            ========================== */}

            {!search && (

                <div className="mt-7 md:mt-9">

                    <div>

                        <h2 className="text-[21px] md:text-2xl font-bold text-gray-900">

                            Khám phá tiện ích

                        </h2>


                        <p className="text-gray-500 text-[13px] md:text-base mt-1">

                            Chọn nhóm phù hợp với nhu cầu của bạn.

                        </p>

                    </div>


                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2.5 md:gap-5 mt-4 md:mt-5">

                        {categories.map(
                            (category) => {

                                const content = (

                                    <>

                                        <div className="flex items-start justify-between">

                                            <div
                                                className={`w-11 h-11 md:w-13 md:h-13 rounded-2xl flex items-center justify-center text-xl md:text-2xl ${category.color}`}
                                            >

                                                {category.icon}

                                            </div>


                                            {category.status === "ready" ? (

                                                <RightOutlined className="text-gray-300 mt-2" />

                                            ) : (

                                                <span className="text-[9px] md:text-[11px] bg-gray-100 text-gray-500 rounded-full px-2 py-1">

                                                    Sắp có

                                                </span>

                                            )}

                                        </div>


                                        <h3 className="font-bold text-[14px] md:text-lg leading-5 mt-3 md:mt-4 text-gray-900">

                                            {category.name}

                                        </h3>


                                        <p className="text-gray-500 text-[11px] md:text-sm leading-4 md:leading-5 mt-1.5">

                                            {category.description}

                                        </p>


                                        <p
                                            className={`text-[10px] md:text-xs font-semibold mt-3 ${
                                                category.status === "ready"
                                                    ? "text-blue-600"
                                                    : "text-gray-400"
                                            }`}
                                        >

                                            {category.count}

                                        </p>

                                    </>

                                );


                                if (
                                    category.status === "ready" &&
                                    category.link
                                ) {

                                    return (

                                        <a
                                            key={category.name}
                                            href={category.link}
                                            className="bg-white border border-gray-200 rounded-2xl p-3.5 md:p-6 hover:shadow-lg hover:border-blue-200 transition block text-black"
                                        >

                                            {content}

                                        </a>

                                    );
                                }


                                return (

                                    <div
                                        key={category.name}
                                        className="bg-gray-50 border border-gray-200 rounded-2xl p-3.5 md:p-6"
                                    >

                                        {content}

                                    </div>

                                );
                            }
                        )}

                    </div>

                </div>

            )}


            {/* =========================
                CÔNG CỤ
            ========================== */}

            <div className="mt-8 md:mt-10">

                <div className="flex items-end justify-between gap-4">

                    <div>

                        <h2 className="text-[21px] md:text-2xl font-bold text-gray-900">

                            {search
                                ? "Kết quả tìm kiếm"
                                : "Tất cả tiện ích đang hoạt động"
                            }

                        </h2>


                        <p className="text-gray-500 text-[13px] md:text-base mt-1">

                            {search
                                ? `Tìm thấy ${filteredTools.length} tiện ích phù hợp`
                                : "Các công cụ hiện có trên Cửa Hàng Y Khoa"
                            }

                        </p>

                    </div>


                    {!search && (

                        <div className="hidden md:flex items-center bg-emerald-50 text-emerald-700 rounded-full px-3 py-1.5 text-xs font-semibold">

                            <SafetyCertificateOutlined className="mr-1.5" />

                            12 tiện ích

                        </div>

                    )}

                </div>


                {filteredTools.length > 0 ? (

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2.5 md:gap-4 mt-4 md:mt-5">

                        {filteredTools.map(
                            (tool) => (

                                <a
                                    key={tool.link}
                                    href={tool.link}
                                    className="group bg-white border border-gray-200 rounded-2xl p-4 md:p-5 hover:shadow-lg hover:border-blue-200 transition block text-black"
                                >

                                    <div className="flex items-start">

                                        <div
                                            className={`w-11 h-11 md:w-12 md:h-12 rounded-xl flex-shrink-0 flex items-center justify-center text-xl ${tool.color}`}
                                        >

                                            {tool.icon}

                                        </div>


                                        <div className="ml-3 flex-1 min-w-0">

                                            <div className="flex items-start justify-between">

                                                <h3 className="font-bold text-[14px] md:text-base text-gray-900 leading-5">

                                                    {tool.name}

                                                </h3>


                                                <RightOutlined className="text-gray-300 text-xs mt-1 ml-2 group-hover:text-blue-500" />

                                            </div>


                                            <p className="text-[10px] md:text-[11px] font-semibold text-blue-600 mt-1">

                                                {tool.group}

                                            </p>

                                        </div>

                                    </div>


                                    <p className="text-gray-500 text-[12px] md:text-[13px] leading-5 mt-3">

                                        {tool.description}

                                    </p>

                                </a>

                            )
                        )}

                    </div>

                ) : (

                    <div className="bg-white border rounded-2xl text-center py-10 md:py-14 mt-5">

                        <SearchOutlined className="text-3xl text-gray-300" />


                        <p className="font-bold text-gray-700 mt-3">

                            Không tìm thấy tiện ích

                        </p>


                        <p className="text-[13px] text-gray-500 mt-1">

                            Thử tìm bằng từ khóa khác.

                        </p>


                        <button
                            type="button"
                            onClick={() =>
                                setSearch("")
                            }
                            className="mt-4 text-blue-600 font-semibold text-sm"
                        >

                            Xem tất cả tiện ích

                        </button>

                    </div>

                )}

            </div>


            {/* =========================
                DÀNH CHO AI
            ========================== */}

            {!search && (

                <div className="mt-9 md:mt-11">

                    <h2 className="text-[21px] md:text-2xl font-bold text-gray-900">

                        Hỗ trợ nhiều nhu cầu chăm sóc

                    </h2>


                    <p className="text-gray-500 text-[13px] md:text-base mt-1">

                        Sử dụng tiện ích phù hợp với từng mục đích theo dõi.

                    </p>


                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mt-4">

                        <div className="bg-white border rounded-2xl p-4 md:p-5">

                            <UserOutlined className="text-xl text-blue-600" />


                            <p className="font-bold text-gray-900 mt-3">

                                Cá nhân & người nhà

                            </p>


                            <p className="text-[13px] text-gray-500 leading-5 mt-1">

                                Ghi lại các chỉ số sức khỏe, lịch dùng thuốc
                                và thông tin cần theo dõi hằng ngày.

                            </p>

                        </div>


                        <div className="bg-white border rounded-2xl p-4 md:p-5">

                            <MedicineBoxOutlined className="text-xl text-emerald-600" />


                            <p className="font-bold text-gray-900 mt-3">

                                Phục hồi chức năng

                            </p>


                            <p className="text-[13px] text-gray-500 leading-5 mt-1">

                                Tạo nhiều hồ sơ riêng và theo dõi kết quả
                                phục hồi của từng người theo thời gian.

                            </p>

                        </div>


                        <div className="bg-white border rounded-2xl p-4 md:p-5">

                            <ReadOutlined className="text-xl text-purple-600" />


                            <p className="font-bold text-gray-900 mt-3">

                                Nhân viên & người học y khoa

                            </p>


                            <p className="text-[13px] text-gray-500 leading-5 mt-1">

                                Ghi nhận và tham khảo cấu trúc của các công cụ
                                đang được triển khai trên website.

                            </p>

                        </div>

                    </div>

                </div>

            )}


            {/* =========================
                LƯU Ý
            ========================== */}

            {!search && (

                <div className="mt-8 md:mt-10">

                    <div className="bg-blue-50 border border-blue-100 rounded-2xl p-4 md:p-5">

                        <div className="flex items-start">

                            <SafetyCertificateOutlined className="text-blue-600 text-xl mt-0.5" />


                            <div className="ml-3">

                                <p className="font-bold text-gray-900">

                                    Lưu ý khi sử dụng

                                </p>


                                <p className="text-[13px] md:text-sm text-gray-600 leading-6 mt-1">

                                    Các tiện ích có mục đích hỗ trợ ghi nhận,
                                    theo dõi và tham khảo thông tin theo thời gian.
                                    Kết quả trên website không thay thế chẩn đoán,
                                    thăm khám hoặc hướng dẫn trực tiếp của nhân viên y tế.

                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            )}

        </div>
    );
}
